angular.module('ecrd.record.bulk').component('recordBulkCertcopy', {
    controller: 'RecordBulkCertcopyController',
    templateUrl: 'modules/record-bulk/components/record-bulk-certcopy/template.html',
    bindings: {
        // Lista de registros afectados
        records: '<',
    },
});
